<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">学职生涯</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/Carrerpostion' }"
        >学职定位</el-breadcrumb-item
      >
    </el-breadcrumb>
    <div class="box">
      <div class="content">
        <div class="top">
          <div class="left">学职定位</div>
          <div class="right">
            <div class="a">
              <img src="./images/warning.png" alt="" />
            </div>
            <div class="title">完成以下六种测评即可查看综合评测报告</div>
            <div class="but" @click="goreport()">
              <button>查看综合评测报告</button>
            </div>
          </div>
        </div>
        <div class="center">
          为了帮助高中学生更好地分析自身特点和优势，六纬生涯推出兴趣测评[Holland]
          、性格测评[MBTI]、能力测评[MIDAS]、职业锚价值观[Career
          anchors]、学力评估[score]、环境评估[CONDITION]。完成所有测评后经过六纬生涯的算法模型，可在线生成综合专业报告，多维度、多方面地让高中学生更加深入了解自我，为高中学生甄选出更适宜自己的专业。
        </div>
        <div class="btn">
          <div
            class="appraisal"
            @click="goTest(item.status)"
            v-for="(item, index) in list"
            :key="index"
          >
            <img :src="item.pic" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetCustomerInfoById } from "@/api/user";
import { Getlista } from "@/api/home";
export default {
  name: "XCarrerpostion",

  data() {
    return {
      list: "",
    };
  },

  async mounted() {
    this.getUserInfo();
    const res = await Getlista(this.$route.query.menuId || "339907260608581");
    this.list = res.data || res.result;
  },

  methods: {
    // 获取个人信息
    async getUserInfo() {
      const res = await GetCustomerInfoById();
      this.studentInfo = res.result.nickName;
      this.$store.commit("user/setStudentInfo", res.result.userExtend.wxId);
      sessionStorage.setItem("setStudentInfo", JSON.stringify(res.result));
    },
    goTest(status) {
      if (status != 1) this.$router.push({ path: "/testing" });
    },
    goreport() {
      this.$router.push({ path: "/report" });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  margin-top: 10px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  min-width: 1050px;
  min-height: 1050px;

  .content {
    padding-top: 25px;
    padding: 25px 40px 0 30px;

    .top {
      display: flex;
      justify-content: space-between;

      .left {
        font-size: 22px;
        color: #333;
      }

      .right {
        display: flex;
        align-items: center;
        margin-bottom: 25px;

        .a {
          width: 20px;
          height: 20px;
          opacity: 1;

          img {
            width: 100%;
          }
        }

        .title {
          font-size: 14px;
          color: #666;
          margin: 0 7px 0 2px;
        }

        .but {
          button {
            cursor: pointer;
            width: 176px;
            height: 35px;
            background: #3964e6;
            border-radius: 3px 3px 3px 3px;
            opacity: 1;
            border: 0;
            color: #fff;
            font-size: 16px;
          }
        }
      }
    }

    .center {
      font-size: 16px;
      color: #666;
      margin-bottom: 53px;
    }

    .btn {
      display: flex;
      justify-content: left;
      margin-left: 80px;
      flex-wrap: wrap;
      width: 100%;

      .appraisal {
        height: 187px;
        margin-right: 2%;
        margin-bottom: 3%;
        cursor: pointer;

        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
